export default __webpack_public_path__ + "static/main_reversed-7a6857587f79b18b29ca8c9cc0ae4477.mp4";